import { Paths } from "@/modules/transaction/common/enum";
import {
  AccountTransferPage,
  BudgetTransferPage,
  CardTransferPage,
  CurrencyExchangePage,
  GroupTransferPage,
  LoanRepaymentPage,
  OwnAccountsTransferPage,
  TransactionHistoryPage,
  TransactionsPage,
} from "@/modules/transaction/pages";
import { FeatureToggle } from "@/shared/common/enums";
import { FeatureToggleRoute } from "@/shared/components";
import { Layout } from "@/shared/layout";
import type { RouteObject } from "react-router-dom";

export const transactionRoutes: RouteObject[] = [
  {
    path: Paths.Transactions,
    element: <Layout/>,
    handle: {
      breadcrumb: () => ({ key: "breadcrumb.transactions" }),
    },
    children: [
      {
        path: "",
        element: <TransactionsPage/>,
      },
      {
        path: Paths.OwnAccountsTransfer,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isOwnAccountTransferAvailable}
            element={<OwnAccountsTransferPage/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.ownAccountTransfer" })
        }
      },
      {
        path: Paths.OwnAccountsTransferUpdate,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isOwnAccountTransferUpdateAvailable}
            element={<OwnAccountsTransferPage isEdit/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.ownAccountTransferUpdate" })
        }
      },
      {
        path: Paths.OwnAccountsTransferCopy,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isOwnAccountTransferCopyAvailable}
            element={<OwnAccountsTransferPage isCopy/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.ownAccountTransferCopy" })
        }
      },
      {
        path: Paths.AccountTransfer,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isAccountTransferAvailable}
            element={<AccountTransferPage/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.accountTransfer" })
        }
      },
      {
        path: Paths.AccountTransferUpdate,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isAccountTransferUpdateAvailable}
            element={<AccountTransferPage isEdit/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.accountTransferUpdate" })
        }
      },
      {
        path: Paths.AccountTransferCopy,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isAccountTransferCopyAvailable}
            element={<AccountTransferPage isCopy/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.accountTransferCopy" })
        }
      },
      {
        path: Paths.CardTransfer,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isCardTransferAvailable}
            element={<CardTransferPage/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.cardTransfer" })
        }
      },
      {
        path: Paths.CardTransferUpdate,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isCardTransferUpdateAvailable}
            element={<CardTransferPage isEdit/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.cardTransferUpdate" })
        }
      },
      {
        path: Paths.CardTransferCopy,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isCardTransferCopyAvailable}
            element={<CardTransferPage isCopy/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.cardTransferCopy" })
        }
      },
      {
        path: Paths.BudgetTransfer,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isBudgetTransferAvailable}
            element={<BudgetTransferPage/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.budgetTransfer" })
        }
      },
      {
        path: Paths.BudgetTransferUpdate,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isBudgetTransferUpdateAvailable}
            element={<BudgetTransferPage isEdit/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.budgetTransferUpdate" })
        }
      },
      {
        path: Paths.BudgetTransferCopy,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isBudgetTransferCopyAvailable}
            element={<BudgetTransferPage isCopy/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.budgetTransferCopy" })
        }
      },
      {
        path: Paths.CurrencyExchange,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isCurrencyExchangeAvailable}
            element={<CurrencyExchangePage/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.currencyExchange" })
        }
      },
      {
        path: Paths.CurrencyExchangeUpdate,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isCurrencyExchangeUpdateAvailable}
            element={<CurrencyExchangePage isEdit/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.currencyExchangeUpdate" })
        }
      },
      {
        path: Paths.CurrencyExchangeCopy,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isCurrencyExchangeCopyAvailable}
            element={<CurrencyExchangePage isCopy/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.currencyExchangeCopy" })
        }
      },
      {
        path: Paths.GroupTransfer,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isGroupTransferAvailable}
            element={<GroupTransferPage/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.groupTransfer" })
        }
      },
      {
        path: Paths.GroupTransferUpdate,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isGroupTransferUpdateAvailable}
            element={<GroupTransferPage isEdit/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.groupTransferUpdate" })
        }
      },
      {
        path: Paths.GroupTransferCopy,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isGroupTransferCopyAvailable}
            element={<GroupTransferPage isCopy/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.groupTransferCopy" })
        }
      },
      {
        path: Paths.LoanRepayment,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isLoanRepaymentAvailable}
            element={<LoanRepaymentPage/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.loanRepayment" })
        }
      },
      {
        path: Paths.LoanRepaymentUpdate,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isLoanRepaymentUpdateAvailable}
            element={<LoanRepaymentPage isEdit/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.loanRepaymentUpdate" })
        }
      },
      {
        path: Paths.LoanRepaymentCopy,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isLoanRepaymentCopyAvailable}
            element={<LoanRepaymentPage isCopy/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.loanRepaymentCopy" })
        }
      },
    ],
  },
  {
    path: Paths.TransactionHistory,
    element: <Layout/>,
    children: [
      {
        path: "",
        element: <TransactionHistoryPage/>,
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.transactionHistory" })
        }
      },
    ],
  },
];
